import type { FC } from "react";
import { Music } from "lucide-react";

type AudioViewerProps = {
  fileId: string;
  fileName: string;
};

export const AudioViewer: FC<AudioViewerProps> = ({ fileId, fileName }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full gap-6 p-2 bg-zinc-100 dark:bg-zinc-900">
      <Music className="w-20 h-20 text-zinc-400" />
      <p className="text-sm font-medium text-zinc-700 dark:text-zinc-300">{fileName}</p>
      <audio
        src={`/api/file/${fileId}`}
        controls
        className="w-full max-w-md"
      >
        Your browser does not support audio playback.
      </audio>
    </div>
  );
};
